import React from "react";

import { VirtuosoShim } from "@app/analytics/MeetingReport/Transcript/styles";
import type {
  MeetingReportSectionContext,
  TranscriptItem as ITranscriptItem,
} from "@app/analytics/MeetingReport/types";
import { isTurnParagraph } from "@app/analytics/MeetingReport/utils";

import TranscriptChapterItem from "./TranscriptChapterItem";
import TranscriptTurnItem from "./TranscriptTurnItem/TranscriptTurnItem";

const TranscriptItem = ({
  context,
  item,
  includeChapters = false,
  onTurnClick,
  previousItem,
  nextItem,
}: {
  context: MeetingReportSectionContext;
  item: ITranscriptItem;
  includeChapters?: boolean;
  onTurnClick?: () => void;
  previousItem?: ITranscriptItem;
  nextItem?: ITranscriptItem;
}) => {
  if (!item) return <VirtuosoShim />;

  if (isTurnParagraph(item)) {
    return (
      <TranscriptTurnItem
        context={context}
        paragraph={item}
        onClick={onTurnClick}
        previousItem={previousItem}
        nextItem={nextItem}
      />
    );
  }

  if (includeChapters) {
    return <TranscriptChapterItem chapter={item} />;
  }

  return <VirtuosoShim />;
};

export default TranscriptItem;
